import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import ClockIcon from 'dibs-vg/dist/react/clock';
import { PdpSharedBlurb } from './PdpSharedBlurb/PdpSharedBlurb';
import { leadTimeTitle } from '../messages/pdpBlurbMessages';

// styles
import styles from './PdpSharedBlurbs.scss';

// helpers
import get from 'lodash.get';

// constants
import { ITEM_LEAD_TIME_AVAILABLE_NOW } from '../../constants/itemConstants';

export function InnerLeadTimeComponent({ leadTime }) {
    return (
        <React.Fragment>
            <span className={styles.leadTimeLabel}>{leadTimeTitle}</span>
            <span className={styles.leadTimeValue}>{leadTime}</span>
        </React.Fragment>
    );
}

InnerLeadTimeComponent.propTypes = {
    leadTime: PropTypes.string,
};

export function PdpSharedBlurbLeadTimeComponent({ item }) {
    const { isNewAndMadeToOrder } = item;
    const leadTimeUrlLabel = get(item, 'attributes.leadTime[0].option.urlLabel');
    const leadTime = get(item, 'attributes.leadTime[0].option.name');
    const isAvailableNow = leadTimeUrlLabel === ITEM_LEAD_TIME_AVAILABLE_NOW;
    // hide Lead Time if it doesn't return [TIME], for example 4 - 5 weeks
    // hide Lead Time if item is NOT isNewAndMadeToOrder
    if (!leadTimeUrlLabel || isAvailableNow || !isNewAndMadeToOrder) {
        return null;
    }

    return (
        <PdpSharedBlurb IconComponent={ClockIcon} dataTn="pdp-blurb-lead-time">
            <InnerLeadTimeComponent leadTime={leadTime} />
        </PdpSharedBlurb>
    );
}

PdpSharedBlurbLeadTimeComponent.propTypes = {
    item: PropTypes.object.isRequired,
};

export const PdpSharedBlurbLeadTime = createFragmentContainer(PdpSharedBlurbLeadTimeComponent, {
    item: graphql`
        fragment PdpSharedBlurbLeadTime_item on Item {
            isNewAndMadeToOrder
            attributes {
                leadTime {
                    option {
                        name
                        urlLabel
                    }
                }
            }
        }
    `,
});
